import { render } from "./DesktopSidebar.vue?vue&type=template&id=138ad036&scoped=true"
import script from "./DesktopSidebar.vue?vue&type=script&lang=js"
export * from "./DesktopSidebar.vue?vue&type=script&lang=js"

import "./DesktopSidebar.vue?vue&type=style&index=0&id=138ad036&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138ad036"]])

export default __exports__